import frFR from './fr_FR';

export default {
  fr_FR: frFR,
};
